var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13.75C7.69035 13.75 8.25 14.3097 8.25 15V35C8.25 37.071 9.92892 38.75 12 38.75H15.5714V25.6945C15.5714 25.004 16.1311 24.4445 16.8214 24.4445H27.1785C27.869 24.4445 28.4285 25.004 28.4285 25.6945V38.75H32C34.071 38.75 35.75 37.071 35.75 35V15C35.75 14.3097 36.3097 13.75 37 13.75C37.6902 13.75 38.25 14.3097 38.25 15V35C38.25 38.4518 35.4517 41.25 32 41.25H27.1785C26.4882 41.25 25.9285 40.6903 25.9285 40V26.9445H18.0715V40C18.0715 40.6903 17.5117 41.25 16.8214 41.25H12C8.54822 41.25 5.75 38.4518 5.75 35V15C5.75 14.3097 6.30965 13.75 7 13.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6518 4.4194C23.1873 2.95493 20.8128 2.95493 19.3483 4.4194L2.88388 20.884C2.39573 21.372 1.60428 21.372 1.11613 20.884C0.627956 20.3957 0.627956 19.6042 1.11613 19.116L17.5805 2.65163C20.0213 0.210851 23.9788 0.210851 26.4195 2.65163L42.884 19.116C43.372 19.6042 43.372 20.3957 42.884 20.884C42.3957 21.372 41.6043 21.372 41.116 20.884L24.6518 4.4194Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.0eed2a3c5bb45f10052fe795782c44f4.svg";
export { ForwardRef as ReactComponent };